import React, { FC, useLayoutEffect, useState, useRef } from 'react';
import './SideMenu.css';
import { useSelector } from 'react-redux';
import { State, actionCreators } from '../../state/index';
import CircularButton from '../CircularButton/CircularButton';
import { faXmark, faCircleUser } from '@fortawesome/free-solid-svg-icons'
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppState, SideMenuState, TrainingModule, TrainingState, UserRole, NavStackItem } from '../../models';
import { useWindowSize } from '../AppSetup/AppSetup'
import { useNavigate } from 'react-router-dom';
import { trainingForModule } from '../LearninHome/LearninHome'

interface SideMenuProps {
  selectedIndex?: number
}

const SideMenu: FC<SideMenuProps> = ({selectedIndex = -1}: SideMenuProps) => {
  const dispatch = useDispatch()
  const { updateSideMenuState, updateRole, updateAppState, updateTrainingState, clearTrainingState, clearNavState, updateNavState } = bindActionCreators(actionCreators, dispatch)
  const navigate = useNavigate()
  const { sideMenuState, role, navState } = useSelector((state: State) => state)

  const dropdownButton = useRef<HTMLDivElement>(null)
  const dropdownContainer = useRef<HTMLDivElement>(null)
  const itemsContainer = useRef<HTMLDivElement>(null)
  const [show, setShow] = useState(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [width, height] = useWindowSize()
  const roles = Object.values(UserRole).sort().filter((r) => r !== UserRole.NotSet)

  useLayoutEffect(() => {
    if (dropdownButton.current !== null && dropdownContainer.current !== null && itemsContainer.current !== null) {
      const padding = 1
      var newTop = dropdownButton.current.offsetTop + dropdownButton.current.clientHeight + padding
      const newLeft = dropdownButton.current.offsetLeft + (dropdownButton.current.clientWidth / 2.0) - (dropdownContainer.current.clientWidth / 2.0)
      dropdownContainer.current.style.left = `${newLeft - padding}px`
      dropdownContainer.current.style.width = `${dropdownButton.current.clientWidth}px`
      if (newTop > (height / 2.0)) {
        // put the drop down above
        newTop = 20
        const heightOfPopover = dropdownButton.current.offsetTop - (padding * 4)
        dropdownContainer.current.style.top = `${newTop}px`
        dropdownContainer.current.style.maxHeight = `${heightOfPopover}px`
        itemsContainer.current.style.maxHeight = `${heightOfPopover - 60}px`
      } else {
        dropdownContainer.current.style.top = `${newTop}px`
        dropdownContainer.current.style.maxHeight = `${height - newTop - 80}px`
        itemsContainer.current.style.maxHeight = `${height - newTop - 140}px`
      }
    }
  })

  function updateIndex(index: number) {
    updateRole(roles[index])
    selectedIndex = index
  }

  const dropDownListNodes = roles.map((listItem, index) => {
      return (
        <div 
          key={index}
          className={`list-item${index === selectedIndex ? ' selected' : ''}`} 
          onClick={() => {
            updateIndex(index)
            setShow(false)
          }}
        >
          {`${listItem}`}
        </div>
      )
  })

  function navigateTo(path: string, training?: TrainingState): void {
    updateSideMenuState(SideMenuState.Closed)
    updateAppState(AppState.NoAnimation)
    if (training) {
      var ns = navState.stack
      const nsi: NavStackItem = {
          trainingModule: training.currentTraining!.trainingModule,
          path: path
      }
      ns.push(nsi)
      updateNavState({stack: ns})
      updateTrainingState(training)
    } else if (path === '/') {
      clearNavState()
      clearTrainingState()
    }
    navigate(path)
  }

  return (
    <div className={`SideMenu${sideMenuState === SideMenuState.Closed ? ' closed' : ''}`}>
      <div ref={dropdownButton} className="user-info borderBottom" onClick={() => { setShow(!show) }}>
        <FontAwesomeIcon icon={faCircleUser} style={{color: "var(--logo-gray)", fontSize: "28px"}} />
        <span>{role}</span>
        <div className={`drop-down ${show ? 'displayed' : 'hidden'}`}>
          <div className={`backdrop${show ? '' : ' hidden'}`} onClick={() => {
              setShow(false)
            }
          }></div>
          
          <div ref={dropdownContainer} className="items-container" style={{ minHeight: '35px'}}>
            <div ref={itemsContainer} className="actual-items">
              {dropDownListNodes}
            </div>
          </div>
        </div>
      </div>
      <div className="section borderBottom">
        <div className='navItem' onClick={() => navigateTo('/')}>Home</div>
      </div>
      <div className="section borderBottom">
        <div className='navItem' onClick={() => navigateTo("/training", trainingForModule(TrainingModule.Kiosk))}>{TrainingModule.Kiosk}</div>
        <div className='navItem' onClick={() => navigateTo("/training", trainingForModule(TrainingModule.SmartShelves))}>{TrainingModule.SmartShelves}</div>
        <div className='navItem' onClick={() => navigateTo("/training", trainingForModule(TrainingModule.Hub))}>{TrainingModule.Hub}</div>
      </div>
      <div className="section borderBottom">
        <div className='navItem' onClick={() => navigateTo("/module", trainingForModule(TrainingModule.ScanningSutures))}>{TrainingModule.ScanningSutures}</div>
        <div className='navItem' onClick={() => navigateTo("/module", trainingForModule(TrainingModule.OrderManagement))}>{TrainingModule.OrderManagement}</div>
        <div className='navItem' onClick={() => navigateTo("/module", trainingForModule(TrainingModule.ExpiryManagement))}>{TrainingModule.ExpiryManagement}</div>
      </div>
      <CircularButton 
        iconProp={faXmark}
        onClick={() => {
          updateSideMenuState(SideMenuState.Closed)
        }}
        style={{ position: "absolute", top: "8px", right: "8px", boxShadow: "unset", color: "var(--night)"}}
      />
    </div>
  )
  
};

export default SideMenu;
